import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { isValid, isText, decodeSpecialCharacters, scrollToTopOf, getRelValue, segmentTrackEvent } from '../../../../utils';
import * as cheerio from 'cheerio';

const ProductSummaryProduct = ({ product, i, isMobile, hidden, isAffiliate }) => {
  const {
    name,
    imageSrcSummary,
    title,
    bodyText,
    brand,
    price,
    oldPrice,
    imageUrl,
    id,
  } = product;
  if (!isValid(product)) {
    return null;
  }

  const handleScroll = (id) => {
    const element = isAffiliate && id === '1' ? '#reviews' : `#${id}`;
    scrollToTopOf(element, 80, 100);
    segmentTrackEvent('article_clicked', {
      action: 'click', label: `read more id#${id}`, linkType: 'read-more', module: 'large-product-summary'
    });
  };

  const decodedProductName = decodeSpecialCharacters(name);
  const $ = cheerio.load(decodedProductName);
  let productName = (isValid(name) && name.includes('<a')) ? $("a").html() : decodedProductName;
  productName = productName.replace(/\d{0,2}\./, '');

  const decodedImageUrl = decodeSpecialCharacters(imageUrl);
  const productRel = getRelValue(decodedImageUrl);
  
  const decodedBodyText = decodeSpecialCharacters(bodyText);
  const brandText = brand || 'Buy';
  let decodedPrice = null;
  let decodedOldPrice = null;

  if (isValid(price) && isText(price)) {
    decodedPrice = price;
    if (isValid(decodedPrice) && decodedPrice.includes('$')) {
      decodedPrice = decodedPrice.replace('$', '');
    }
  }

  if (isValid(oldPrice) && isText(oldPrice)) {
    decodedOldPrice = oldPrice;
    if (isValid(decodedOldPrice) && decodedOldPrice.includes('$')) {
      decodedOldPrice = decodedOldPrice.replace('$', '');
    }
  }

  let buttonText = (isValid(decodedPrice))
    ? `$${decodedPrice} at ${brandText}`
    : `Buy at ${brand}`;
  buttonText = (isValid(decodedOldPrice) && isValid(decodedPrice))
    ? `<s style="font-weight:200;">$${decodedOldPrice}</s>; $${decodedPrice} at ${brandText}`
    : `${buttonText}`;

  let buyButton;
  if (isValid(decodedBodyText) && decodedBodyText.includes('<div class="wp-block-button">')) {
    const $ = cheerio.load(decodedBodyText);
    const element = $("a.wp-block-button__link");
    element.attr('data-link-type', 'buy-button');
    buyButton = $.html(element[0]);
    if (isValid(buyButton) && buyButton.includes('<s>')) {
      buyButton = buyButton.replace(/<s>/g, '<s style="font-weight:200;">');
    }
    if (isValid(buyButton) && buyButton.includes('|')) {
      buyButton = buyButton.replace(/\|/g, '<span style="font-weight:200;">|</span>');
    }
  }

  const button = buyButton ? (
    <div
      className="price-button"
      dangerouslySetInnerHTML={{ __html: buyButton }}
    ></div>
  ) : (
    <div className="price-button">
      <a href={decodedImageUrl} target="_blank" rel={productRel} dangerouslySetInnerHTML={{ __html: buttonText }} data-link-type="buy-button">
      </a>
    </div>
  );

  return (
    <div className={`product ${hidden ? 'hidden' : ''}`}>
      <div className="product-number">{i + 1}</div>
      <a className="product-image-link" href={decodedImageUrl} target="_blank" rel={productRel} data-link-type="image-link">
        <img className="product-image" src={imageSrcSummary}></img>
      </a>
      <div className="product-info">
        {title && <p className="product-superlative">{title}</p>}
        <h3 className="product-name" dangerouslySetInnerHTML={{ __html: productName }} data-link-type="text-link"></h3>
        <p className="read-more" onClick={() => handleScroll(id)}>read more</p>
        {isMobile && (
          button
        )}
      </div>
      {!isMobile && (
        button
      )}
    </div>
  );
};

ProductSummaryProduct.propTypes = {
    data: PropTypes.array,
};

export default ProductSummaryProduct;
